import {
  ROGUE_APP_PARAM,
  ROGUE_APP_VERSION_PARAM,
  ROGUE_APP_TAB_PARAM,
  DEVICE_PLATFORM_PARAM_SNAKECASE,
  DEVICE_PLATFORM_PARAM_CAMELCASE,
  DEVICE_UID_PARAM_CAMELCASE,
} from '@/js/app-bridge/helpers'

export interface IAppContext {
  version: string,
  platform: string,
  deviceUid?: string,
  tab?: string,
}

export function getAppContext(queryParams: Record<string, string> = {}, cookieString = '') {
  const cookies: { [key: string]: string } = {}
  cookieString.split('; ')
    .filter(cookie => cookie.length > 0)
    .forEach(cookie => {
      const [key, val] = cookie.split('=')
      cookies[key] = val
    })

  const params: any = Object.assign({}, queryParams, cookies)

  if (params[ROGUE_APP_PARAM]) {
    return {
      version   : params[ROGUE_APP_VERSION_PARAM],
      platform  : params[DEVICE_PLATFORM_PARAM_SNAKECASE] || params[DEVICE_PLATFORM_PARAM_CAMELCASE] || 'ios',
      deviceUid : params[DEVICE_UID_PARAM_CAMELCASE] || undefined,
      tab       : params[ROGUE_APP_TAB_PARAM] || undefined,
    }
  }

  return null
}

export function getAppContextBrowser() {
  const { search } = window.location
  const queryParams: Record<string, string> = {}

  try {
    search.substring(1)
      .split('&')
      .forEach(param => {
        const [key, val] = param.split('=')
        queryParams[key] = decodeURIComponent(val)
      })
  } catch (e) {
    // could not parse query string -- default to noop
  }

  try {
    if (window.localStorage && window.localStorage.getItem('__rgAppDbg')) {
      return JSON.parse(window.localStorage.getItem('__rgAppDbg') || '{}')
    }
  } catch (e) {
    //
  }

  return getAppContext(queryParams, document.cookie)
}
